<template>
  <div style="margin-top: 35px">
    <div class="uk-visible@m">
      <div class="uk-width-1-1 uk-grid-small" uk-grid>
        <div class="uk-width-1-2">
          <div uk-grid>
            <div class="uk-width-2-3">
              <h2>{{$t('homeContent.featuredContent')}}</h2>
            </div>
            <div class="uk-width-1-3 uk-text-right">
              <span class="see-more-text add-pointer" @click="redirect">+ {{$t('general.seeMore')}}</span>
            </div>
          </div>
            <div class="divider"></div>
            <div v-if="!categories[0].content.length" class="uk-flex uk-flex-center">
              <spinner class="spinner-margin"></spinner>
            </div>
            <div v-else>
              <ShortCategoryContentRow v-bind:content="limitedContent(0, 3)"
                                       v-bind:screenWidth="screenWidth"></ShortCategoryContentRow>
              <ShortCategoryContentRow v-bind:content="limitedContent(3, 6)"
                                       v-bind:screenWidth="screenWidth"></ShortCategoryContentRow>
            </div>
          </div>
        <div class="uk-width-1-2">
          <div class="divider marketing-margin"></div>
          <marketing-carousel></marketing-carousel>
        </div>
      </div>
    </div>
    <div v-for="(category, index) in categories" :class="{'uk-hidden@m': index === 0}">
      <category-content-row
        v-bind:content="category.content"
        v-bind:screenWidth="screenWidth"
        :heading="category.heading"
        :type="category.type">
      </category-content-row>
      <div v-if="index === 0" class="divider margin-top"></div>
      <marketing-carousel v-if="index === 0" class="marketing-image-container"></marketing-carousel>
    </div>
  </div>
</template>
<script>
  import CategoryContentRow from './category-content/category-content-row'
  import MarketingCarousel from './marketing/marketing-carousel'
  import ShortCategoryContentRow from './category-content/short-category-content-row'
  import screen from '../../utils/screen-util'
  import * as categories from '../../enums/categories'
  import Router from '../../router/index'
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import Spinner from '../ui-components/spinner/spinner'
  import enviro from '../../plugins/environment/index'
  import ping from '../../utils/ping-util'
  import metrics from '../../services/metrics'
  import * as event from '../../enums/mixpanel-event'
  import mixpanel from '../../services/mixpanel'

  export default {
    name: 'HomeContent',
    components: {
      MarketingCarousel,
      CategoryContentRow,
      ShortCategoryContentRow,
      Spinner
    },
    data() {
      return {
        studentActivitiesId: [],
        student: categories.STUDENT_ACTIVITIES,
        manageYourClassroomId: [],
        manageYourClassroom: categories.MANAGE_YOUR_CLASSROOM,
        trySomethingNewId: [],
        trySomethingNew: categories.TRY_SOMETHING_NEW,
        featuredContentId: [],
        featuredContent: categories.FEATURED_CONTENT,
        standardsContentId: [],
        standardsContent: categories.STANDARDS_CONTENT,
        topPrimaryId: [],
        topPrimary: categories.TOP_PRIMARY,
        topSecondaryId: [],
        topSecondary: categories.TOP_SECONDARY,
        featuredPublisherContentId: [],
        featuredPublisherContents: categories.FEATURED_PUBLISHER_CONTENT,
        screenWidth: screen.resolveWidth()
      }
    },
    methods: {
      ...mapActions(['fetchCategoryContent', 'fetchSortedContent', 'updateSelectedCategory', 'setDefaultSorting']),
      ...mapMutations(['updateSorting', 'updateSelectedCategory']),
      redirect() {
        this.updateSelectedCategory(categories.FEATURED_CONTENT)
        Router.push('search')
      },
      resolveWindowWidth() {
        this.screenWidth = screen.resolveWidth()
      },
      limitedContent(start, end) {
        return this.categories[0].content.slice(start, end)
      },
      fetchCategories() {
        if (this.isGermanLocale || this.isNorwegianLocale) {
          this.fetchRegionalizedCategories()
        } else {
          this.fetchDefaultCategories()
        }
      },
      fetchDefaultCategories() {
        if (!this.studentActivitiesCategory.length) {
          this.fetchCategoryContent({'category': categories.STUDENT_ACTIVITIES, 'labels': this.studentActivitiesId})
        }
        if (!this.manageYourClassroomCategory.length) {
          this.fetchCategoryContent({'category': categories.MANAGE_YOUR_CLASSROOM, 'labels': this.manageYourClassroomId})
        }
        if (!this.trySomethingNewCategory.length) {
          this.fetchCategoryContent({'category': categories.TRY_SOMETHING_NEW, 'labels': this.trySomethingNewId})
        }
        if (!this.featuredContentCategory.length) {
          this.fetchCategoryContent({'category': categories.FEATURED_CONTENT, 'labels': this.featuredContentId})
        }
        if (!this.standardsContentCategory.length) {
          this.fetchCategoryContent({'category': categories.STANDARDS_CONTENT, 'labels': this.standardsContentId})
        }
      },
      fetchRegionalizedCategories() {
        if (!this.featuredContentCategory.length) {
          this.fetchCategoryContent({'category': categories.FEATURED_CONTENT, 'labels': this.featuredContentId})
        }
        if (!this.topPrimaryContent.length) {
          this.fetchCategoryContent({'category': categories.TOP_PRIMARY, 'labels': this.topPrimaryId})
        }
        if (!this.topSecondaryContent.length) {
          this.fetchCategoryContent({'category': categories.TOP_SECONDARY, 'labels': this.topSecondaryId})
        }
        if (!this.featuredPublisherContent.length) {
          this.fetchCategoryContent({'category': categories.FEATURED_PUBLISHER_CONTENT, 'labels': this.featuredPublisherContentId})
        }
      },
      setDevEnviroLabels () {
        if (this.isGermanLocale) {
          this.featuredContentId = [categories.DEV_GERMAN_FEATURED_ID]
          this.topPrimaryId = [categories.DEV_GERMAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.DEV_GERMAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.DEV_GERMAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else if (this.isNorwegianLocale) {
          this.featuredContentId = [categories.DEV_NORWEGIAN_FEATURED_ID]
          this.topPrimaryId = [categories.DEV_NORWEGIAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.DEV_NORWEGIAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.DEV_NORWEGIAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else {
          this.studentActivitiesId = [categories.DEV_STUDENT_ACTIVITIES_ID]
          this.manageYourClassroomId = [categories.DEV_MANAGE_YOUR_CLASSROOM_ID]
          this.trySomethingNewId = [categories.DEV_TRY_SOMETHING_NEW_ID]
          this.featuredContentId = [categories.DEV_FEATURED_CONTENT_ID]
          this.standardsContentId = [categories.DEV_STANDARDS_CONTENT_ID]
        }
      },
      setPreprodEnviroLabels() {
        if (this.isGermanLocale) {
          this.featuredContentId = [categories.PREPROD_GERMAN_FEATURED_ID]
          this.topPrimaryId = [categories.PREPROD_GERMAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.PREPROD_GERMAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.PREPROD_GERMAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else if (this.isNorwegianLocale) {
          this.featuredContentId = [categories.PREPROD_NORWEGIAN_FEATURED_ID]
          this.topPrimaryId = [categories.PREPROD_NORWEGIAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.PREPROD_NORWEGIAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.PREPROD_NORWEGIAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else {
          this.studentActivitiesId = [categories.PREPROD_STUDENT_ACTIVITIES_ID]
          this.manageYourClassroomId = [categories.PREPROD_MANAGE_YOUR_CLASSROOM_ID]
          this.trySomethingNewId = [categories.PREPROD_TRY_SOMETHING_NEW_ID]
          this.featuredContentId = [categories.PREPROD_FEATURED_CONTENT_ID]
          this.standardsContentId = [categories.PREPROD_STANDARDS_CONTENT_ID]
        }
      },
      setProdEnviroLabels() {
        if (this.isGermanLocale) {
          this.featuredContentId = [categories.PROD_GERMAN_FEATURED_ID]
          this.topPrimaryId = [categories.PROD_GERMAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.PROD_GERMAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.PROD_GERMAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else if (this.isNorwegianLocale) {
          this.featuredContentId = [categories.PROD_NORWEGIAN_FEATURED_ID]
          this.topPrimaryId = [categories.PROD_NORWEGIAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.PROD_NORWEGIAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.PROD_NORWEGIAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else {
          this.studentActivitiesId = [categories.PROD_STUDENT_ACTIVITIES_ID]
          this.manageYourClassroomId = [categories.PROD_MANAGE_YOUR_CLASSROOM_ID]
          this.trySomethingNewId = [categories.PROD_TRY_SOMETHING_NEW_ID]
          this.featuredContentId = [categories.PROD_FEATURED_CONTENT_ID]
          this.standardsContentId = [categories.PROD_STANDARDS_CONTENT_ID]
        }
      },
      setEnviroLabels () {
        if (enviro.isDev()) {
          this.setDevEnviroLabels()
        } else if (enviro.isUat() || enviro.isPreprod()) {
          this.setPreprodEnviroLabels()
        } else if (enviro.isProd()) {
          this.setProdEnviroLabels()
        }
      }
    },
    computed: {
      ...mapGetters(['studentActivitiesCategory', 'manageYourClassroomCategory', 'trySomethingNewCategory', 'mostPopularCategory', 'sorting', 'featuredContentCategory', 'standardsContentCategory', 'topSecondaryContent', 'topPrimaryContent', 'featuredPublisherContent']),
      defaultCategories() {
        return [{content: this.featuredContentCategory, heading: this.$t('homeContent.featuredContent'), type: categories.FEATURED_CONTENT},
          {content: this.trySomethingNewCategory, heading: this.$t('homeContent.trySomethingNew'), type: categories.TRY_SOMETHING_NEW},
          {content: this.standardsContentCategory, heading: this.$t('homeContent.standardsContent'), type: categories.STANDARDS_CONTENT},
          {content: this.studentActivitiesCategory, heading: this.$t('homeContent.studentActivities'), type: categories.STUDENT_ACTIVITIES},
          {content: this.manageYourClassroomCategory, heading: this.$t('homeContent.manageYourClassroom'), type: categories.MANAGE_YOUR_CLASSROOM}
        ]
      },
      regionalizedCategories() {
        return [{content: this.featuredContentCategory, heading: this.$t('homeContent.featuredContent'), type: categories.FEATURED_CONTENT},
          {content: this.topSecondaryContent, heading: this.$t('homeContent.topSecondary'), type: categories.TOP_SECONDARY},
          {content: this.topPrimaryContent, heading: this.$t('homeContent.topPrimary'), type: categories.TOP_PRIMARY},
          {content: this.featuredPublisherContent, heading: this.$t('homeContent.featuredPublisherContent'), type: categories.FEATURED_PUBLISHER_CONTENT}
        ]
      },
      categories() {
        if (this.isGermanLocale || this.isNorwegianLocale) {
          return this.regionalizedCategories
        } else {
          return this.defaultCategories
        }
      },
      isGermanLocale() {
        return this.$i18n.locale === 'de' && this.$feature('german-regionalised-categories').enabled
      },
      isNorwegianLocale() {
        return this.$i18n.locale === 'nb' && this.$feature('norwegian-regionalised-categories').enabled
      }
    },
    mounted() {
      ping.url('https://google.com', 0.3)
        .then(delta => {
          metrics
            .sendMetric(
              metrics.CATEGORIES.THIRD_PARTY_CALLS,
              metrics.CP_TAGS.NETWORK_LATENCY,
              delta,
              metrics.TYPE.TIMER)
        })
      mixpanel.track(event.HOMEPAGE_OPENED)
      this.setEnviroLabels()
      this.setDefaultSorting(this.sorting.items)
      this.updateSelectedCategory(null)
      this.fetchCategories()
      this.resolveWindowWidth()
      window
        .addEventListener(
          'resize',
          this.resolveWindowWidth)
    },
    destroyed() {
      window
        .removeEventListener(
          'resize',
          this.resolveWindowWidth)
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../styles/breakpoints.scss';
  @import '../../styles/colours.scss';

  .divider {
    height: 2px;
    opacity: 0.2;
    background: $slate;
  }
  .see-more-text {
    color: $content-link-blue;
    font-size: 18px;
  }

  h2 {
    font-size: 22px;
    color: $content-text;
  }
  .spinner-margin {
    margin-top: 200px;
  }
  .marketing-margin {
    margin-top: 25px
  }
  .margin-top {
    margin-top: 35px;
  }
  .marketing-image-container {
    width: 90%;
    height: 90%;
    position: relative;
    margin: 0 auto;
    text-align: center;
  }

  .uk-grid {
    margin: 0;
  }
  .uk-first-column {
    padding: 0;
  }
</style>
